import { render, staticRenderFns } from "./SpecialBanner.component.vue?vue&type=template&id=669cbdf4&scoped=true"
import script from "./SpecialBanner.component.vue?vue&type=script&lang=js"
export * from "./SpecialBanner.component.vue?vue&type=script&lang=js"
import style0 from "./SpecialBanner.component.vue?vue&type=style&index=0&id=669cbdf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669cbdf4",
  null
  
)

export default component.exports